import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postPresentCancel = (params) => {
    return axios.post(`${backendHost}/api/admin/present/cancel`, params);
};

export {
    postPresentCancel
}